import React from "react"
import { getObject, setObject } from "utils/storage"

export const STORAGE_KEY = "cw.download.01"

// Setup our context with initial state
const DownloadContext = React.createContext({
  isVisible: true,
  sentSms: false,
  setIsVisible: () => {},
  setSentSms: () => {},
  reset: () => {},
})

// Build our provider (wrapper)
export const DownloadContextProvider = ({ children }) => {
  const storedVal = getObject(STORAGE_KEY)
  const [isVisible, setIsVisible] = React.useState(!storedVal.hidden)
  const [sentSms, setSentSms] = React.useState(!!storedVal.sentSms)

  React.useEffect(() => {
    setObject(STORAGE_KEY, { hidden: !isVisible })
  }, [isVisible])

  React.useEffect(() => {
    setObject(STORAGE_KEY, { sentSms: !!sentSms })
  }, [sentSms])

  const reset = () => {
    setIsVisible(false)
  }

  return (
    <DownloadContext.Provider
      value={{
        sentSms,
        isVisible,
        setIsVisible,
        setSentSms,
        reset,
      }}
    >
      {children}
    </DownloadContext.Provider>
  )
}

// Make a simple export for our context for class-based components
export const withDownloadContext = Component => {
  return function WrapperComponent(props) {
    return (
      <DownloadContext.Consumer>{state => <Component {...props} downloadContext={state} />}</DownloadContext.Consumer>
    )
  }
}

export default DownloadContext
